var map = {
	"./account.svg": "f2f9",
	"./accounts.svg": "c76a",
	"./douyin-new.svg": "bf22",
	"./feedback.svg": "131f",
	"./feedbacks.svg": "d849",
	"./gift-new.svg": "97ff",
	"./gold_charter.svg": "06a0",
	"./help.svg": "5745",
	"./helps.svg": "1651",
	"./jingxuan.svg": "1a0b",
	"./lack-song.svg": "b135",
	"./like-song.svg": "27b6",
	"./maiba-new.svg": "5fd1",
	"./mine-vip.svg": "d26e",
	"./more.svg": "991c",
	"./my-music.svg": "4978",
	"./my-musics.svg": "07c1",
	"./new-song.svg": "95a8",
	"./newMore.svg": "cdb2",
	"./record.svg": "9468",
	"./records.svg": "24ff",
	"./send-bless.svg": "93d5",
	"./send-photo.svg": "1df6",
	"./shu.svg": "0261",
	"./song-likes.svg": "2d84",
	"./zhiding.svg": "7b44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "650d";